import { FC } from 'react';
import {
    Modal,
    Space,
    Typography,
} from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import { IoIosCloseCircle } from 'react-icons/io';
import { BsLightbulbFill } from 'react-icons/bs';
import { useRequestsContext } from '../../context/requests.ctx';
import { AvailableDrivers } from './AvailableDrivers';
import { IRequest } from '../../../../interfaces/requests.interface';

const { Text } = Typography;

const HelpTag: FC<{ request: IRequest | null }> = ({ request }) => {
    const { t } = useTranslation('small-fleet-orders');
    return (
        <div className="help">
            <div className="help__tag">
                <BsLightbulbFill color="var(--color-dark)" size={12} style={{ verticalAlign: 'middle' }} />
                {t('HELP_TAG')}
            </div>
            <Text>
                <Trans
                    t={t}
                    i18nKey="ASSIGN_DRIVER_DESCRIPTION"
                    components={{ b: <b /> }}
                    values={{
                        bookingNumericId: request?.bookingNumericId,
                        customerName: request?.customerName,
                    }}
                />
            </Text>
        </div>
    );
};

const AssignModal: FC<{ request: IRequest | null }> = ({ request }) => {
    const { t } = useTranslation('small-fleet-orders');

    const {
        handleAssignDriver,
        setAssignDriver,
    } = useRequestsContext();

    return (
        <Modal
            centered
            open={Boolean(request)}
            onCancel={() => setAssignDriver(null)}
            title={t('ASSIGN_DRIVER_HEADER')}
            footer={null}
            width={750}
            closeIcon={<IoIosCloseCircle size={20} color="var(--color-dark-2)" style={{ verticalAlign: 'middle' }} />}
            style={{ borderRadius: 16 }}
            bodyStyle={{ padding: 16 }}
        >
            <Space direction="vertical" size={24}>
                <HelpTag request={request} />
                <AvailableDrivers
                    request={request}
                    handleAssignDriver={handleAssignDriver}
                />
            </Space>
        </Modal>
    );
};

export { AssignModal };
